import { transformGamesWithJoinedOdds } from "../../services/UserGroup.js";
import { APP_CONFIG, getHeaders } from "../constants/global-variables.js";

export async function getFeaturedMatches(sport_id) {
    const options = {
        method: "GET",
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/featuredmatches/${sport_id}`;

    try {
        const res = await axios.post(url, { sport_id: sport_id }, getHeaders());

        return transformGamesWithJoinedOdds(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getFeaturedSportMatches(sport_id) {
    const options = {
        method: "GET",
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/prematchgamesbysport/${sport_id}`;

    try {
        const res = await axios.post(url, { sport_id: sport_id }, getHeaders());

        return transformGamesWithJoinedOdds(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}


export async function getTodayMatches() {
    const options = {
        method: "GET",
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/prematchgames24hour`;

    try {
        const res = await axios.post(url, null, getHeaders());
        return transformGamesWithJoinedOdds(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}